import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from '../Navigate';
import globalAppUserStore from '../../stores/globalAppUserStore';
import { useHookstate } from '@hookstate/core';
import globalAuthStateStore from '../../stores/globalAuthStateStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faUser, faRightFromBracket, faArrowDown, faArrowDownShortWide, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { DialogControl } from '../controls/DialogControl';
import { SelectListControl } from '../controls';
import { useAppUserManager } from '../../hooks/useManagers';
import { useRef } from 'react';
import _ from 'lodash';

const ProfileNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const globalAuthState = useHookstate(globalAuthStateStore);
  const authState = globalAuthState.get();
  const authMgr = useAppUserManager();
  const globalAppUserState = useHookstate(globalAppUserStore);
  const appUserStateItem = globalAppUserState.get();
  const userProfile = authMgr?.GetGlobalState()?.userProfile;
  const idTokenClaims = authMgr?.GetGlobalAuthState()?.idTokenClaims;
  const { isAuthenticated } = authState;
  const [profileMenuActive, setProfileMenuActive] = useState(false);
  const [userProfileFile, setUserProfileFile] = useState(userProfile?.File);
  const [showSchoolYearSelection, setShowSchoolYearSelection] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [schoolYears, setSchoolYears] = useState(null);
  const [selectedSchoolYear, setSelectedSchoolYear] = useState(null);
  const [showSchoolYearDropdown, setShowSchoolYearDropdown] = useState(false);

  const logout = async () => {
    navigate("/logout");
  };

  const login = () => {
    navigate('/login');
  }

  const loadSchoolYears = (maxRows) => {
    let tmpSchoolYears = [];
    Object.keys(appUserStateItem.schoolYearMap).forEach(schoolYear => {
      tmpSchoolYears.push({
        Text: (appUserStateItem.schoolYearMap[schoolYear]?.Title ?? schoolYear) + `${schoolYear == appUserStateItem.currentSchoolYear && schoolYear == appUserStateItem.selectedSchoolYear ? ('  (Current & Selected School Year)') : schoolYear == appUserStateItem.currentSchoolYear ? ' (Current Year)' : (schoolYear == appUserStateItem.selectedSchoolYear ? ' (Selected Year)' : '')}`,
        Value: schoolYear
      });
    })
    setSchoolYears(tmpSchoolYears.slice(-maxRows));
  }

  useEffect(() => {
    if (isAuthenticated && appUserStateItem && (selectedSchoolYear === null || schoolYears === null) && appUserStateItem.schoolYearMap !== null) {
      loadSchoolYears();
      setSelectedSchoolYear(appUserStateItem.selectedSchoolYear);
    }
  }, [appUserStateItem]);

  useEffect(() => {
    if(userProfile) {
      let roles = userProfile.Roles
      const hasAdminRole = roles?.includes('NIETAdmin') || roles?.includes('SysAdmin');
      const hasSchoolAdminRole = roles?.includes('OrganizationAdmin') || roles?.includes('SchoolManagement') || roles?.includes('SARpts') || roles?.includes('CODESchoolAdminEvaluator') || roles?.includes('CODETeacherEvaluator');
      //const hasSchoolAdminRole = false; //turn off prev school years for schoolAdmin

      if(hasAdminRole || hasSchoolAdminRole) {
        var maxRows = (!hasAdminRole && hasSchoolAdminRole) ? 3 : hasAdminRole ? 99 : 0;
        loadSchoolYears(maxRows);
        setShowSchoolYearDropdown(true);
      }
    }
  }, [userProfile])

  const changeSchoolYear = () => {
    setShowSchoolYearSelection(false);
    if (selectedSchoolYear && selectedSchoolYear != appUserStateItem.selectedSchoolYear) {
      setRefreshing(true);
      globalAppUserState.merge({ selectedSchoolYear: selectedSchoolYear });
      sessionStorage.setItem("SelectedSchoolYear", selectedSchoolYear);
      window.location.href = window.location.href;
      return { Success: false };
    }
    else
      return { Success: true };


  }

  const profileRefs = useRef(null);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (!profileRefs.current?.contains(e.target) && !profileMenuRef.current?.contains(e.target)) {
        setProfileMenuActive(false);
      }
    };

    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    }
  }, []);

  useEffect(() => {
    if (!profileMenuActive) {
      return undefined;
    }

    const firstMenuItem = profileMenuRef.current?.querySelector('.drop-down-option:not(:disabled)');
    firstMenuItem?.focus();

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        setProfileMenuActive(false);
        profileRefs.current?.focus?.();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, [profileMenuActive]);

  useEffect(() => {
    if (userProfile?.File && userProfile?.File?.FileUrl) {
      setUserProfileFile(userProfile?.File);
    }
  }, [userProfile?.File])

  const profileOptions = () => {
    const isProfileActive = '/profile' === pathname.toLowerCase();
    return (<>
      <button
        type="button"
        onClick={() => setProfileMenuActive(!profileMenuActive)}
        className={`profile-dropdown`}
        aria-expanded={profileMenuActive}
        aria-controls="profile-menu"
        id="profile-menu-trigger"
        ref={(el) => { profileRefs.current = el }}
      >
        <span className={'name-and-icon-wrapper'}>
          <span className={'profile-wrapper'}>
            <span className="profile-image">
              {userProfileFile?.FileUrl ? <img src={userProfileFile.FileUrl} alt="" />
                : <FontAwesomeIcon className={"btn-icon-fa"} icon={faUser} aria-hidden="true" />}
            </span>
            <span className={'display-name'}>{idTokenClaims?.name}</span>
            <span className={'menu-btn'}><FontAwesomeIcon icon={faChevronDown} className={`drop-down-icon${profileMenuActive ? ' active' : ''}`} aria-hidden="true" /></span>
          </span>
        </span>
      </button>
      {profileMenuActive ? <div className={'active-drop-down'} id="profile-menu" aria-labelledby="profile-menu-trigger" ref={profileMenuRef}>
        <button type="button" disabled={isProfileActive} className={`drop-down-option${isProfileActive ? ' active' : ''}`} onClick={() => {
          if (!isProfileActive) {
            setProfileMenuActive(false);
            navigate('/profile');
          }
        }}>
          <span>{isProfileActive && <span className="active-menu-indicator" aria-hidden="true" />}Profile</span>
        </button>
        {/*<div className={`drop-down-option${'/my-dashboard' === pathname.toLowerCase() ? ' active' : ''}`} style={'/profile' === pathname.toLowerCase() ? { cursor: 'default' } : {}} onClick={() => {
          if ('/my-dashboard' !== pathname.toLowerCase()) {
            setProfileMenuActive(false);
            navigate('/my-dashboard');
          }
        }}>
          Dashboard
      </div>*/}
        {showSchoolYearDropdown &&
          <>
            <button type="button" className={'drop-down-option'} onClick={() => {
              setShowSchoolYearSelection(true);
              setProfileMenuActive(false);
            }}>
              School Year <span className={`selected-school-year${selectedSchoolYear != appUserStateItem.currentSchoolYear ? ' not-current-year' : ''}`}>{` ${appUserStateItem.schoolYearMap[selectedSchoolYear]?.Title ?? selectedSchoolYear}`}</span>
            </button>
          </>
        }
        <button type="button" className={'drop-down-option'} onClick={logout}>
          Logout
          <FontAwesomeIcon icon={faRightFromBracket} aria-hidden="true" />
        </button>
      </div> : null}
    </>)
  }



  let render = <div className='profile'><button type="button" className='profile-btn' onClick={login}>SIGN IN</button></div>
  if (isAuthenticated) {
    render = <div className={`profile authenticated`}>
      {profileOptions()}
      <DialogControl
        openDialog={showSchoolYearSelection}
        title={`Please select a school year`}
        subTitle={'By selecting a new school year and clicking submit the application will reloaded you will loose any unsaved changes.'}
        onOk={() => { return changeSchoolYear() }}
        loading={refreshing}
        onCancel={() => { setShowSchoolYearSelection(false) }}
        okText={'Change'}
        loadingOk={refreshing}
        className={'school-year-selection-dialogue'}
      >
        <SelectListControl
          field={{ FieldName: 'SchoolYear' }}
          textValuePairs={schoolYears}
          value={selectedSchoolYear}
          onChange={(e) => {
            setSelectedSchoolYear(e.target.value);
            //TODO: Reload the context... with the new school year in mind... figure out how this works..
          }}
          className='school-year-select'
        >
        </SelectListControl>
      </DialogControl>
    </div>
  };

  return (render);
}

export default ProfileNav;